import React from 'react';
import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Text,
  Link,
} from '@chakra-ui/react';
import { FaLinkedin } from 'react-icons/fa';

const FundInFocusBain: React.FC = () => (
  <>
    {/* members */}
    <Flex
      as="section"
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height={{ xs: '450px', sm: '300px' }}
      minH={{ xs: '450px', sm: '300px' }}
      maxH="450px"
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/jpg/blogBanner.jpg"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir="column"
        px={{ xs: '20px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Heading
          as="h1"
          mb="20px"
          variant="reportCardTitle"
          fontSize={{ xs: '26px', sm: '28px', md: '32px', lg: '38px' }}
          color="white"
          lineHeight={{ xs: '34px', md: '39px', lg: '42px' }}
        >
          FUND IN FOCUS: Bain Capital&apos;s Winning Formula Combines Expertise
          and Rigor in Investment Decisions
        </Heading>
        <Text
          fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
          fontWeight="600"
          color="white"
          lineHeight="21px"
        >
          Ashish Kotecha, Partner and Head of Asia Private Equity Portfolio
          Group, Bain Capital
        </Text>
      </Container>
    </Flex>
    <Container
      as="section"
      maxW="container.xl"
      pb="80px"
      pt="40px"
      minH="420px"
      display={{ xs: 'flex', md: 'inherit' }}
      flexDirection="column"
    >
      <Box as="main" w="100%" pb="40px">
        <Text variant="blogAnswer">
          Welcome to our ‘Fund in Focus’ series where we profile our member
          funds, underscore their investment philosophy, and highlight some of
          their interesting work. Today we speak to Ashish Kotecha of Bain
          Capital. In this feature he throws light on how the fund’s global
          platform, deep expertise in key sectors, and focus on creating value
          through a dedicated group of experts – help to challenge conventional
          thinking and drive growth.
        </Text>
      </Box>

      <Img
        src="/jpg/ashishKotecha.jpg"
        alt="Anjani Bansal"
        boxSize="300px"
        float={{ xs: 'right', md: 'left' }}
        alignSelf={{ xs: 'center', md: 'flex-start' }}
        mx={{ xs: '0px', md: '0px' }}
        mr={{ xs: '0px', md: '40px', lg: '60px', xl: '70px' }}
        mb="20px"
        objectFit="contain"
      />
      <Box>
        <Flex flexDir={{ xs: 'column', lg: 'row' }} rowGap="16px">
          <Heading
            textAlign={{ xs: 'center', md: 'left' }}
            fontWeight="800"
            color="blue.400"
          >
            Spokesperson: Ashish Kotecha, Partner and Head of Asia Private
            Equity Portfolio Group, Bain Capital
            {/* <Link
              href="https://globalbrains.com/en"
              target="_blank"
              rel="noreferrer"
            >
              Global Brain
            </Link> */}
          </Heading>
          <Flex
            columnGap={{ xs: '4px', md: '16px' }}
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            transform={{ xs: 'translateX(12px)', md: 'none' }}
          >
            <Box alignSelf="center">
              <Link
                href="https://www.linkedin.com/in/ashish-kotecha-45067/?originalSubdomain=in"
                target="_blank"
              >
                <IconButton
                  aria-label="linkedin"
                  icon={
                    <FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
          </Flex>
        </Flex>
        <Box
          ml={{ xs: 'auto', md: '345px', lg: '370px' }}
          mr={{ xs: 'auto', md: '0px' }}
          width={{ xs: '160px', md: '80px' }}
          h="2px"
          bgColor="primary.500"
          borderRadius="5px"
          mt={{ xs: '16px', md: '10px' }}
          mb="15px"
        />
        <Box>
          <Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
            1. How would you describe the investment philosophy of Bain Capital?
          </Heading>
          <Text variant="blogAnswer" pb="20px">
            Founded in 1984, we pioneered a consulting-based approach to private
            equity investing, partnering closely with founders, families, and
            management teams to offer the insights that challenge conventional
            thinking, build great businesses and improve operations. Over time,
            we have organically expanded this approach across asset classes to
            build one of the strongest alternative asset platforms in the world.
            <br />
            <br />
            Our primary objective is to be the partner of choice for great
            companies as they grow. We help companies improve their competitive
            position by expanding into new products and markets, growing
            productivity, and strengthening their operations. Ultimately, we
            believe our growth-oriented model results in stronger companies that
            employ the best people, are socially responsible, deliver strong
            returns over the long-term, and create lasting impact in the
            communities in which we live.
            <br />
            <br />
            This value-added approach to investing is supported by our global
            platform and our deep expertise in key vertical sectors, including
            healthcare, consumer/retail, financial and business services,
            industrials, and technology.
          </Text>
        </Box>
        {/* Question 2 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            2. Given India’s improving macro-economic situation, tell us more
            about the firm’s strategy to deploy capital in this geography across
            asset classes
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              We started our Mumbai office in 2008 with a combination of
              existing Bain Capital professionals and experienced investors in
              India to integrate localized insights and relationships into our
              global investment approach. We have grown to become one of the
              largest private equity teams in India with 15 investment
              professionals.
              <br />
              <br />
              As a platform, we have invested in more than 25 companies in
              India, and partnered with a host of different founders, families,
              corporates, and management teams. We have helped these businesses
              expand into new products and markets, strengthen their operations,
              and positioned them for long-term success. We remain very excited
              about the opportunity here and are looking actively to increase
              our deployment in India as we continue to pursue high-conviction
              investments across our core sectors – consumer / retail, financial
              and business services, technology, industrials, and healthcare.
              <br />
              <br />
              Thematically, we are looking to build on our experience base and
              differentiated set of operational resources to provide founders,
              families, and management teams with flexible solutions to
              professionalize and grow their companies. While we look for
              companies that are well positioned to drive growth over the
              long-term, we are also uniquely set up to invest in situations
              that involve performance turnarounds, complex corporate carveouts,
              platform buildouts and large-scale mergers.
              <br />
              <br />
              From an asset class perspective, we partner with our Special
              Situations team to provide a greater range of capital solutions.
              They invest across the capital structure in India, bringing
              together credit, equity, corporate, and real asset expertise.
            </Text>
          </Box>
        </Box>

        {/* Question 3 */}

        <Box py="16px">
          <Heading variant="blogQuestion" pt="28px">
            3. In what ways does Bain Capital contribute to the growth and
            development of the companies it invests in?
          </Heading>
          <Box pt="16px">
            <Text variant="blogAnswer" pb="8px">
              Bain Capital Private Equity pioneered the value-added approach to
              private equity investing. We were among the first private equity
              firms to establish a dedicated global portfolio group staffed with
              operating and strategy professionals who partner with management
              teams. This group has 75+ people in it today and includes several
              specialists who act as advisors to each of our portfolio companies
              across functional areas like Capital Markets, Talent, Digital, IT,
              Financial Controls, and Supply Chain to name a few.
            </Text>
            <Text variant="blogAnswer" mt="12px">
              Our portfolio group, in conjunction with our investment
              professionals – most of whom come from strategic consulting
              backgrounds, form a collaborative team that enables us to create
              lasting impact for our portfolio companies and helps them reach
              their full potential. <br />
              <br />
              These integrated deal and portfolio teams work with companies on
              strategic, operational, and organizational topics helping ensure
              differential focus and execution on a highly prioritized set of
              value creation levers.
            </Text>
          </Box>
        </Box>

        {/* Question 4 */}
        <Flex py="16px">
          <Box>
            <Heading variant="blogQuestion" pt="16px">
              4. Few years back PE firms looked at ESG related issued from a
              risk management perspective; whereas now they look at ESG and
              sustainability as a key value driver. Illustrate how can PE firms
              ensure success with ESG value creation?
            </Heading>
            <Box>
              <Text variant="blogAnswer" py="16px">
                We think holistically about returns and believe that ESG and
                value creation are intrinsically linked. We start with a
                strategic, fact-based and diligence-driven investment approach
                that by definition includes a multitude of environmental, social
                and governance (ESG) considerations.
                <br />
                <br />
                Post investment, we engage with our companies in five key areas
                where we believe our impact can be the greatest – Active
                Governance and Stewardship, Sustainable Growth & Reducing
                Climate Impact, Fair Employment, Engagement & Well-being, DE&I
                and Community Engagement.
                <br />
                <br />
                We believe that good ESG practices in these areas lead to better
                investment outcomes while considering the firm’s broader impact
                on the environment and society.
              </Text>
            </Box>
          </Box>
        </Flex>

        {/* Question 5 */}
        <Flex pt="8" pb="20px" gap="1rem">
          <Box>
            <Heading variant="blogQuestion" pb="20px" pt="12px">
              5. How does Bain Capital approach due diligence and risk
              assessment when evaluating potential investment opportunities in
              India?
            </Heading>

            <Text variant="blogAnswer" pt="8px">
              We invest when we have high conviction that a business is in a
              structurally attractive industry, where it is addressing crucial
              industry or market issues with a sustainable competitive moat, and
              it is led by a highly capable and motivated team.
              <br />
              <br />
              We arrive at our investments by leveraging deep global vertical
              expertise / themes, with high analytical rigor and practical
              perspectives from our portfolio group. Over the last several
              years, we have also built a real center of excellence in our
              global macro team, who provide critical context setting that allow
              us to invest across market cycles in an increasingly complex
              global macro environment.
            </Text>
          </Box>
        </Flex>
        {/* Question 6 */}
        <Flex pt="8" pb="20px" gap="1rem">
          <Box>
            <Heading variant="blogQuestion" pb="20px" pt="12px">
              6. Quite a few of the deals of your deals are in BFSI and IT &
              ITES. Will these sectors remain high on your focus?
            </Heading>

            <Text variant="blogAnswer" pt="8px">
              Absolutely – each of these industries enjoys compelling long term
              structural tailwinds. Having invested in over 7 BFSI /IT ITES
              companies, we also have a differential ability to diligence and
              support companies in these industries.
              <br />
              <br />
              We have been through cycles in these industries, worked
              extensively ‘in the trenches’ helping these businesses grow and,
              finally have successfully exited many investments. Lots of lessons
              learnt and insights developed that gives us continued confidence
              to invest in these industries.
              <br />
              <br />
              In fact, we have invested in 2 new deals in these sectors over the
              last 12 months - CitiusTech – a leading healthcare focused IT
              services company, and in 360One – one of India’s leading wealth
              and asset management firms.
            </Text>
          </Box>
        </Flex>
        {/* Question 7 */}
        <Flex pt="8" pb="20px" gap="1rem">
          <Box>
            <Heading variant="blogQuestion" pb="20px" pt="12px">
              7. You have fully exited JM Baxi this year. How do you see the
              Infra/ Logistics space going forward in terms of opportunities?
            </Heading>

            <Text variant="blogAnswer" pt="8px">
              There are several tailwinds driving the infra/logistics space –
              including a real acceleration in demand for consumer and business
              products, the government’s ‘Make in India’ initiative that has
              spurred a wave of capacity additions, and a global push to
              diversify supply chains.
              <br />
              <br />
              As an active investor globally in industrials, we will actively
              look for opportunities that fit our value-added investment
              approach.
            </Text>
          </Box>
        </Flex>
      </Box>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        The content in this section is curated by Team IVCA. For any feedback,
        connect with&nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default FundInFocusBain;
